var _ellipse, _polygon, _path, _path2, _circle, _polygon2, _polygon3, _path3, _path4, _path5, _polygon4, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _circle2, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "baf10ad2-6463-4f51-bd6b-04bf2837b3a8",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 884.59563,
    height: 679.04269,
    viewBox: "0 0 884.59563 679.04269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "location_tracking") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.48425,
    cy: 662.4512,
    rx: 124.48425,
    ry: 16.59149,
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "63.767 385.875 63.767 543.875 67.767 645.875 100.767 645.875 98.767 547.875 111.767 453.875 133.767 532.875 147.767 643.875 187.767 641.875 166.767 527.875 160.767 385.875 63.767 385.875",
    fill: "#2f2e41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.46891,751.35331v10s-23,22-4,22,20-5,20-5,7,0,7-2v-24Z",
    transform: "translate(-157.70219 -110.47866)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M336.46891,751.35331v10s23,22,4,22-20-5-20-5-7,0-7-2v-24Z",
    transform: "translate(-157.70219 -110.47866)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104.76672,
    cy: 227.87465,
    r: 24,
    fill: "#ffb8b8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "85.767 235.875 86.767 271.875 118.767 270.875 118.767 242.875 85.767 235.875",
    fill: "#ffb8b8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "100.767 267.875 85.767 256.875 79.767 391.875 150.767 389.875 133.767 271.875 118.767 257.501 100.767 267.875",
    fill: "#cfcce0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M238.46891,375.35331l5.46283-12.33821,1.53717,22.33821s13,42,12,79,5,124-3,125-42,3-42-4-2-193-2-193Z",
    transform: "translate(-157.70219 -110.47866)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M276.46891,364.35331l12,13,30,11s0,128,6,158,17,33,3,34-13-4-13-4,10-50-3-60-38-68-36-100S274.46891,364.35331,276.46891,364.35331Z",
    transform: "translate(-157.70219 -110.47866)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M202.46891,548.35331l2,9s1,38,15,33-1-36-1-36v-6Z",
    transform: "translate(-157.70219 -110.47866)",
    fill: "#ffb8b8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "169.267 415.375 157.767 429.875 153.767 416.875 157.267 402.375 169.267 415.375",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M305.46891,387.35331,314.969,387.07a7.14352,7.14352,0,0,1,7.49993,5.28331c2,6,9,67,9,67s6,10,4,25l-7,56-20-22,3-50Z",
    transform: "translate(-157.70219 -110.47866)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M215.46891,392.35331l-2.65525-1.4236s-14.34475,5.4236-13.34475,9.4236-8,144-5,149,27,1,27,1Z",
    transform: "translate(-157.70219 -110.47866)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M285.25888,323.45006s8.00646-10.857-5.6457-13.95542c0,0-11.45342-9.33881-22.75441-2.24717,0,0-8.47334-3.43189-11.92748,2.62416,0,0-.78373-3.39669,3.29692-4.98526,0,0-8.47335-3.43189-10.04559,7.276,0,0-5.33844,10.15486-2.98726,20.34493s3.44935,11.44518,3.44935,11.44518-3.22222-21.1137,11.99979-19.97251,33.43879-5.62491,32.96472,6.33806,1.56506,15.544,1.56506,15.544S298.98845,330.3884,285.25888,323.45006Z",
    transform: "translate(-157.70219 -110.47866)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 139.17081,
    width: 516.59563,
    height: 330.84626,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 416.40424,
    y: 175.80851,
    width: 419.78714,
    height: 257.57085,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 416.40424,
    y: 225.27377,
    width: 419.78714,
    height: 15.81483,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 416.40424,
    y: 302.59072,
    width: 419.78714,
    height: 15.81483,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 474.84005,
    y: 260.41784,
    width: 177.47754,
    height: 15.81483,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 416.40424,
    y: 384.30068,
    width: 419.78714,
    height: 15.81483,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 466.93263,
    y: 175.80851,
    width: 15.81483,
    height: 218.15679,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 762.14281,
    y: 175.80851,
    width: 15.81483,
    height: 135.56823,
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 642.65297,
    y: 175.80851,
    width: 15.81483,
    height: 257.57085,
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 552.157,
    y: 305.22653,
    width: 15.81483,
    height: 128.15283,
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 650.56039,
    cy: 310.49814,
    r: 20.20784,
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M810.01978,110.47866a76.40751,76.40751,0,0,0-76.4075,76.4075c0,42.19868,76.4075,201.93411,76.4075,201.93411s76.4075-159.73543,76.4075-201.93411A76.40751,76.40751,0,0,0,810.01978,110.47866Zm0,112.792a36.38453,36.38453,0,1,1,36.38453-36.38452A36.38454,36.38454,0,0,1,810.01978,223.27068Z",
    transform: "translate(-157.70219 -110.47866)",
    fill: "#6c63ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.2c8ad03d763d912fb4125068ab07afe3.svg";
export { ForwardRef as ReactComponent };